<template>
  <section
    id="topic"
    class="app-topic"
    :class="{ loaded: loadedView.indexOf('topic') !== -1 }"
  >
    <img src="../../assets/topic@1x.png" srcset="../../assets/topic@2x.png 2x" class="app-topic__img" >
    <img src="../../assets/m-topic@1x.png" srcset="../../assets/m-topic@2x.png 2x" class="app-topic__img mb" >
    <p class="app-topic__tip">行情专线直连上金所，资金独立托管工商银行，合法合规</p>
    <div class="app-topic-summary">
      <!-- <a class="app-topic__download" href="https://jiaoyixia.com/" target="_blank">
        <span>下载交易侠</span>
      </a> -->

      <BtnDownload class="app-topic__download" :diy="true" @click="() => triggerBtnVisible(!showDownload)" />

      <div class="app-topic__signin" @click="onSignUp">
        <span>报名参赛</span>
      </div>

      <div class="app-topic-summary-content">
        <img src="../../assets/total-label-2@1x.png" srcset="../../assets/total-label-2@2x.png 2x" class="app-topic-summary-content__label">
        <Num v-model="numberOfParticipants" />
        <img src="../../assets/icon-man.png" class="app-topic-summary-content__unit">

        <!-- <div class="gap"></div>

        <img src="../../assets/total-label-1@1x.png" srcset="../../assets/total-label-1@2x.png 2x" class="app-topic-summary-content__label label-2">
        <Num v-model="gameVolume" />
        <img src="../../assets/icon-hand.png" class="app-topic-summary-content__unit"> -->
      </div>
    </div>

    <transition name="fadeInUp">
      <div v-if="showDownload" class="download-wrap">
        <div class="download-item windows">
          <a href="https://cdn.jin10.com/pcclient/TraderMasterWin.exe"><span><i class="iconfont icon-windows"></i>Windows版下载</span></a>
        </div>
        <div class="download-item mac">
          <a href="https://apps.apple.com/cn/app/%E4%BA%A4%E6%98%93%E4%BE%A0-%E4%B8%93%E4%B8%9A%E8%A1%8C%E6%83%85%E5%88%86%E6%9E%90%E8%BD%AF%E4%BB%B6/id1221761136?mt=12" target="_blank"><span><i class="iconfont icon-ios"></i>Mac版下载</span></a>
        </div>
        <div class="download-item iphone">
          <a href="javascript:;"><span><i class="iconfont icon-ios"></i>iPhone版下载</span></a>

          <div class="download-item__mask">
            <span>手机扫描二维码下载</span>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAAEEAQMAAAD0xthJAAAABlBMVEX///8AAABVwtN+AAABuklEQVRo3u2ZO46EMAyGPaJIyRFylBxtOFqOwhEoKdB4/YghPGalbdd2gVD00Vj27/gHIOIcqDFneqwJcRvw0x37IyQrZc4zjCvAsMHrQ4c48XEO4ol4I9YyQ14AEjOa04mPPRMAI66UsYFKKwipICZwaxUUxFei9RziwiIlNfbclT4IU+15XNKatqFl7EHXgxDCIqOqVCMewgdBaZmg8NxfRhSZsjRWPvZHkAZNrb2SapAWDx0G8Y1oV0dWKZIpeKEUWel13RlRKWNcYqJB/IHMttZzQZwJlBEvcw4SrR7SlYB74TkjQIiakaYYcJHhh1IGXc/5I+iV32XToqbTnnvXLmNB9AQnr+rgl7lvKnUMfk+E9JxsFiP7G4Oo9r0r3RBg6ps1YdpzeNRVEBeCUzqxHOUmUkrwh9Wy7omgV6umkac6aI2pBrUIoifszoynua/LR5n9EefdVGpMLY/d7fFFdCaFTXVQ96te3J4grg483xxX8wul5wp6JMxxlrmv9yDruSB+I3ibVzuo3aTvfzU8EeKf4h4PNeaFOP7xYecn88Jq7kYQJ6Jz4KEZZOpulHr/Z/H/iYi/xQ83HEWJsT/T6AAAAABJRU5ErkJggg==">
          </div>
        </div>
        <div class="download-item android">
          <a href="javascript:;"><span><i class="iconfont icon-android"></i>Android版下载</span></a>

          <div class="download-item__mask">
            <span>手机扫描二维码下载</span>
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQQAAAEEAQMAAAD0xthJAAAABlBMVEX///8AAABVwtN+AAABuklEQVRo3u2ZO46EMAyGPaJIyRFylBxtOFqOwhEoKdB4/YghPGalbdd2gVD00Vj27/gHIOIcqDFneqwJcRvw0x37IyQrZc4zjCvAsMHrQ4c48XEO4ol4I9YyQ14AEjOa04mPPRMAI66UsYFKKwipICZwaxUUxFei9RziwiIlNfbclT4IU+15XNKatqFl7EHXgxDCIqOqVCMewgdBaZmg8NxfRhSZsjRWPvZHkAZNrb2SapAWDx0G8Y1oV0dWKZIpeKEUWel13RlRKWNcYqJB/IHMttZzQZwJlBEvcw4SrR7SlYB74TkjQIiakaYYcJHhh1IGXc/5I+iV32XToqbTnnvXLmNB9AQnr+rgl7lvKnUMfk+E9JxsFiP7G4Oo9r0r3RBg6ps1YdpzeNRVEBeCUzqxHOUmUkrwh9Wy7omgV6umkac6aI2pBrUIoifszoynua/LR5n9EefdVGpMLY/d7fFFdCaFTXVQ96te3J4grg483xxX8wul5wp6JMxxlrmv9yDruSB+I3ibVzuo3aTvfzU8EeKf4h4PNeaFOP7xYecn88Jq7kYQJ6Jz4KEZZOpulHr/Z/H/iYi/xQ83HEWJsT/T6AAAAABJRU5ErkJggg==">
          </div>
        </div>
        <div class="download-item linux">
          <a href="javascript:;"><span><i class="iconfont icon-linux"></i>Linux版下载</span></a>

          <div class="download-item__mask">
            <div class="item-sub">
              <a class="item-sub__linux" href="https://cdn.jin10.com/linuxclient/TraderMaster_18_04.deb">Ubuntu18.04下载</a>
              <a class="item-sub__linux" href="https://cdn.jin10.com/linuxclient/TraderMaster_20_04.deb">Ubuntu20.04下载</a>
              <a class="item-sub__linux" href="https://cdn.jin10.com/linuxclient/TraderMaster_deepin_15_11.deb">Deepin15.11下载</a>
              <a class="item-sub__linux" href="https://cdn.jin10.com/linuxclient/TraderMaster_deepin_20_beta.deb">Deepin20_beta下载</a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeInUp">
      <div v-if="showBottom" class="fixed-bottom app-topic-summary">
        <BtnDownload class="app-topic__download" />

        <div class="app-topic__signin" @click="onSignUp">
          <span>报名参赛</span>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { throttle } from "throttle-debounce"
import device from '@jin10/utils/lib/device'
import { getStatData } from '@/api'
import BtnDownload from '../BtnDownload'
import Num from './Num'

export default {
  name: 'Topic',
  props: {
    user: [Object, null],
    loadedView: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    Num,
    BtnDownload
  },
  data() {
    return {
      gameVolume: '',
      numberOfParticipants: '',
      showBottom: false,
      showDownload: false
    }
  },
  mounted() {
    this.getStatData()

    if (device.isMobile) {
      document.addEventListener('scroll', throttle(500, () => {
        if (document.querySelector('.app-topic-summary').getBoundingClientRect().top < 0) {
          this.showBottom = true
        } else {
          this.showBottom = false
        }
      }))
    }

    this.$bus.$on('showDownload', () => {
      this.triggerBtnVisible(true)
    })

    setInterval(() => {
      this.getStatData()
    }, 3 * 1000)
  },
  methods: {
    getStatData() {
      getStatData().then(res => {
        // this.gameVolume = String(res.data.gameVolume || 0)
        if (this.numberOfParticipants < res.data.numberOfParticipants) {
          this.numberOfParticipants = String(res.data.numberOfParticipants || 0)
        }
      })
    },
    onSignUp() {
      window._czc.push(['_trackEvent', '点击', '报名参赛'])

      this.$bus.$emit('modalChange', true)
    },
    triggerBtnVisible (bool) {
      if (device.isMobile) {
        location.href = device.isAndroid ? 'https://cdn.jin10.com/pcclient/apk/traderMasterAndroid.apk' : 'https://apps.apple.com/cn/app/%E4%BA%A4%E6%98%93%E4%BE%A0-%E4%B8%93%E4%B8%9A%E8%A1%8C%E6%83%85%E5%88%86%E6%9E%90%E8%BD%AF%E4%BB%B6/id1221755976'
      } else {
        this.showDownload = bool
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
@import "../../styles/mixin.scss";

.fadeInUp-enter-active, .fadeInUp-leave-active {
  transform: translate(0, 0);
  transition: all .5s;
}

.fadeInUp-enter, .fadeInUp-leave-to {
  opacity: 0;
  transform: translate(0, 100%);
}

.app-topic {
  overflow: hidden;

  .fixed-bottom {
    display: none;
  }

  .download-wrap {
    width: percentage(1200px / $baseWidth);
    min-width: 800px;
    margin: 30px auto 0;
    text-align: center;
    display: flex;
    justify-content: center;

    .download-item {
      position: relative;
      z-index: 9;
      margin: 0 10px;
      width: percentage(160px / 984px);
      padding-top: percentage(45px / 984px);

      &:hover {
        .download-item__mask {
          opacity: 1;
          transform: translate(-50%, -100%);
        }


        a {
          background: url("../../assets/link-active.png") center/contain no-repeat;
        }
      }

      &__mask {
        position: absolute;
        top: -5px;
        left: 50%;
        width: 80%;
        opacity: 0;
        transform: translate(-50%, 0);
        background: #1D203E;
        transition: all .4s ease;
        z-index: 1;
        text-align: center;

        .item-sub {
          padding: 8px 0;

          a {
            position: static;
            font-size: 12px;
            line-height: 26px;
            color: #B6CBEC;
            background: none !important;
          }

          a:hover {
            background: #282C4E !important;
          }
        }

        span {
          font-size: 12px;
          color: #B6CBEC;
          white-space: nowrap;
        }
        img {
          margin-top: 4px;
          width: percentage(90px / 120px);
        }
      }

      a {
        display: inline-block;
        position: absolute;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #b6cbec;
        font-weight: 600;
        vertical-align: middle;
        background: url("../../assets/link-normal.png") center/contain no-repeat;

        span {
          white-space: nowrap;
          @include middle();
        }

        i {
          font-size: 12px;
          margin-right: 2px;
        }
      }

    }
  }

  .gap {
    display: inline-block; 
    width: 5%;
  }

  &.loaded {
    .app-topic__img {
      transform: scale3d(1,1,1);
      // animation: zoomIn .5s .5s forwards;
    }
  }

  &__tip {
    position: relative;
    margin: 0 auto;
    margin-top: percentage(-68px / $baseWidth);
    text-align: center;
    font-size: 22px;
    color: #ECBEB6;
    font-weight: 600;
    width: percentage(984px / $baseWidth);
  }

  &__img {
    width: percentage(984px / $baseWidth);
    margin: percentage(52px / $baseWidth) auto percentage(40px / $baseWidth);
    display: block;
    transition: transform .4s;
    transition-delay: .3s;
    transform: scale3d(0.3, 0.3, 0.3);

    &.mb {
      display: none;
    }
  }

  &-summary {
    position: relative;
    width: percentage(783px / $baseWidth);
    min-width: 640px;
    min-height: 86px;
    margin: percentage(84px / $baseWidth) auto 0;
    padding-top: percentage(90px / $baseWidth);
    @include image-2x("../../assets/total-bg@1x.png", center top, no-repeat, 100% auto);
    box-sizing: border-box;

    &-content {
      @include middle();
      margin-top: 6px;
      white-space: nowrap;
      width: 100%;
      text-align: center;
      color: #fff;

      &__num {
        height: 22px;
        padding: 0 1px;
      }

      &__unit {
        // width: percentage(20px / 783px);
        height: 15px;
        margin-left: 4px;
      }

      &__label {
        // width: percentage(93px / 783px);
        // min-width: 96px;
        height: 17px;
        margin-right: 10px;

        &.label-2 {
          width: percentage(115px / 783px);
          min-width: 118px;
        }
      }
    }
  }

  /deep/.num-list {
    .num {
      width: 21px;
      height: 22px;

      img {
        height: 22px;
      }
    }
  }

  &__download, &__signin {
    position: absolute;
    top: percentage(-40px / 90px);
    width: percentage(193px / 783px);
    padding-top: percentage(60px / 783px);
    font-weight: 500;
    color: #fff;
    cursor: pointer;

    span, /deep/span {
      font-size: 20px;
      white-space: nowrap;
      font-weight: 500;
      cursor: pointer;
      @include middle()
    }
  }

  &__download {
    right: 50%;
    margin-right: 6px;
    @include image-2x("../../assets/btn-3@1x.png", center top, no-repeat, 100% auto);

    &:hover {
      @include image-2x("../../assets/btn-3-active@1x.png", center top, no-repeat, 100% auto);
    }
  }

  &__signin {
    left: 50%;
    margin-left: 6px;
    @include image-2x("../../assets/btn-2@1x.png", center top, no-repeat, 100% auto);

    &:hover {
      @include image-2x("../../assets/btn-2-active@1x.png", center top, no-repeat, 100% auto);
    }
  }
}

@media screen and (min-width: 1440px) {
  
  .app-topic {
    .download-wrap {
      .download-item {
        a {
          font-size: 16px;
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  
  .app-topic {
    .download-wrap {
      .download-item {
        a {
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (min-width: 2550px) {
  
  .app-topic {
    &__download, &__signin {
      span, /deep/span {
        font-size: 28px;
      }
    }

    &-summary-content__label {
      height: 24px;
    }

    /deep/.num-list {
      .num {
        width: 24px;
        height: 28px;

        img {
          height: 28px;
        }
      }
    }
  }
}


@include mobile {

  .app-topic {

    $baseWidth: 414px;

    .download-wrap {
      display: none;
    }

    &__tip {
      margin: 0 auto;
      width: 90%;
      margin-top: -12%;
      font-size: 16px;
    }

    .fixed-bottom {
      position: fixed;
      display: block;
      bottom: 0;
      left: 0;
      z-index: 39;
      width: 100%;
      height: 10px;
      padding-top: percentage(40px / 414px);
      min-height: 40px;
      background: none;
    }

    .gap {
      display: block;
      padding-top: percentage(4px / $baseWidth);
    }

    &__img {
      display: none;
      width: 100%;
      margin: percentage(20px / $baseWidth) auto 0;
      &.mb {
        display: block;
      }
    }

    &-summary {
      width: 100%;
      min-width: 100%;
      margin: percentage(42px / $baseWidth) auto 0;
      padding-top: percentage(96px / $baseWidth);
      @include image-2x("../../assets/m-total-bg@1x.png", center top, no-repeat, cover);

      &-content {
        @include middle();
        margin-top: 6px;
        white-space: nowrap;
        width: 100%;
        text-align: center;
        color: #fff;

        &__num {
          height: 20px;
          padding: 0 1px;
        }

        &__unit {
          height: 14px;
          // width: percentage(16px / 414px);
          // min-width: 18px;
          // max-width: 20px;
          margin-left: 4px;
        }

        &__label {
          height: 16px;
          // width: percentage(83px / 414px);
          // min-width: 84px;
          // max-width: 110px;
          margin-right: 10px;

          &.label-2 {
            width: percentage(107px / 414px);
            min-width: 107px;
            max-width: 134px;
          }
        }
      }
    }

    &__download, &__signin {
      position: absolute;
      top: percentage(-24px / 96px);
      width: percentage(129px / 414px);
      padding-top: percentage(40px / 414px);
      span {
        font-size: 14px;
      }
    }
  }
}

@include pad {
  .app {

    $baseWidth: 525px;

    .gap {
      display: block;
      padding-top: percentage(10px / $baseWidth);
    }

    &-topic-summary-content__num {
      height: 26px;
    }
  
    &-topic {
      &__download, &__signin {
        span, /deep/span {
          font-size: 21px !important;
          font-weight: 600 !important;
        }
      }
    }
  }
}

</style>
